import dayjs from 'dayjs'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import CopyIcon from '../assets/icons/JSX/CopyIcon'
import TravelServiceIcon from '../assets/icons/JSX/TravelServiceIcon'
import WelcomerCategoryIcon from '../assets/icons/JSX/WelcomerCategoryIcon'
import PetCategoryIcon from '../assets/icons/JSX/PetCategoryIcon'
import TplCategoryIcon from '../assets/icons/JSX/TplCategoryIcon'
import Colors from '../assets/styles/Colors'
//
//
//
const HorizontalPolicyCard: React.FC<{
  companyName?: string
  insurerName?: string
  policyNumber?: string
  dateFrom?: string | Date
  dateTo?: string | Date
  style?: React.CSSProperties
  policyStatus?: string
  type?: string
  policyId?: number
  iconChildren?: React.ReactNode
  onClick?: () => void
}> = ({
  companyName,
  insurerName,
  policyNumber,
  dateFrom,
  dateTo,
  style,
  policyStatus = true,
  type,
  policyId,
  iconChildren,
  onClick,
}) => {
  // for copy function
  const [copied, setCopied] = useState<boolean>(false)

  // copy policy numner
  const copyPolicyNumber = (e: any) => {
    e.stopPropagation()
    navigator.clipboard.writeText(e.currentTarget.innerText)
    setCopied(true)
    toast.success('დაკოპირდა')
    // for change color in copied text
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  // ქლოვალიდეზი ფირფიტებია ხის 1 პაჩკა

  return (
    <>
      <Card onClick={onClick}>
        <Item>
          {/* <TravelServiceIcon /> */}
          {type?.toLowerCase() === 'travelpolicy' && <TravelServiceIcon />}
          {type?.toLowerCase() === 'welcomerpolicy' && <WelcomerCategoryIcon />}
          {type?.toLowerCase() === 'tplpolicy' && <TplCategoryIcon />}
          {type?.toLowerCase() === 'internationaltplpolicy' && <TplCategoryIcon />}
          {type?.toLowerCase() === 'petpolicy' && <PetCategoryIcon />}
        </Item>
        <Item>
          <div>{String(type?.match(/[A-Z][a-z]+/g))?.replace(',', ' ')}</div>
          <div>{companyName}</div>
        </Item>
        <Item>
          <div>{insurerName}</div>
          <div>
            <span>Policy N:</span>
            <PolicyNumberSpan $copied={copied} onClick={(event) => copyPolicyNumber(event)}>
              {policyNumber} <CopyIcon />
            </PolicyNumberSpan>
          </div>
        </Item>
        <Item>
          <div>Start: {dayjs(dateFrom).format('DD.MM.YYYY')}</div>
          <div>End: {dayjs(dateTo).format('DD.MM.YYYY')}</div>
        </Item>
        <Item>
          <StatusDiv>
            {policyStatus}{' '}
            {policyStatus && (
              <StatusBall
                style={{
                  backgroundColor:
                    policyStatus === 'active'
                      ? Colors.java
                      : policyStatus === 'pending'
                      ? Colors.Primary
                      : Colors.primaryRed,
                }}
              />
            )}
          </StatusDiv>
        </Item>
        {iconChildren && <Item>{iconChildren}</Item>}
      </Card>

      <MobileCard onClick={onClick}>
        <ContentStylesMobile>
          <div>
            <Title>
              <span>
                <HeaderDiv>{String(type?.match(/[A-Z][a-z]+/g))?.replace(',', ' ')}</HeaderDiv>
                <div>{companyName}</div>
              </span>
            </Title>
            <Title>
              <>{iconChildren}</>
            </Title>
          </div>
          <div>
            <Title>
              <span>
                <HeaderDiv>{insurerName}</HeaderDiv>
                <div>
                  <PolicyNumberSpan $copied={copied} onClick={(event) => copyPolicyNumber(event)}>
                    {policyNumber} <CopyIcon />
                  </PolicyNumberSpan>
                </div>
              </span>
            </Title>
            <Title>
              <MobileIcon>
                {/* <TravelServiceIcon /> */}
                {type?.toLowerCase() === 'travelpolicy' && <TravelServiceIcon />}
                {type?.toLowerCase() === 'welcomerpolicy' && <WelcomerCategoryIcon />}
                {type?.toLowerCase() === 'tplpolicy' && <TplCategoryIcon />}
                {type?.toLowerCase() === 'internationaltplpolicy' && <TplCategoryIcon />}
                {type?.toLowerCase() === 'petpolicy' && <PetCategoryIcon />}
              </MobileIcon>
            </Title>
          </div>
          <hr />
          <div>
            <Title>
              <HeaderDiv>Start: {dayjs(dateFrom).format('DD.MM.YYYY')}</HeaderDiv>
            </Title>
            <Title>
              <MobileStatusDiv>
                {policyStatus}{' '}
                {policyStatus && (
                  <StatusBall
                    style={{
                      backgroundColor:
                        policyStatus === 'active'
                          ? Colors.java
                          : policyStatus === 'pending'
                          ? Colors.Primary
                          : Colors.primaryRed,
                    }}
                  />
                )}
              </MobileStatusDiv>
            </Title>
          </div>
        </ContentStylesMobile>
      </MobileCard>
    </>
  )
}
// <{ $copied: boolean }>
//  border-color: ${({ $copied }) => ($copied === true ? "green" : "transparent")};
//
// styles
const StatusDiv = styled.div`
  position: relative;
  text-transform: capitalize;
`
const StatusBall = styled.span`
  height: 5px;
  width: 5px;
  border-radius: 50px;
  background-color: ${Colors.primaryGreen};
  user-select: none;
  pointer-events: none;
  padding: 0px !important;
  position: absolute;
  /* right: -12px; */
  margin-left: 5px;
  top: 20px;
  ${Responsive.mobile} {
    top: 8px;
    right: -10px;
  }
  ${Responsive.tablet} {
    top: 10px;
    right: -10px;
  }
`
const PolicyNumberSpan = styled.span<{ $copied: boolean }>`
  cursor: pointer;
  color: ${({ $copied }) => ($copied === true ? Colors.primaryGreen : Colors.primaryGrey)};
  ${Responsive.tablet} {
    margin-right: -5px;
  }
  ${Responsive.mobile} {
    margin-right: -5px;
  }
`
const Item = styled.div`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  user-select: none;
  /* first div */
  span:first-of-type {
    padding: 0px;
  }
  div {
    &:first-of-type {
      color: ${Colors.primaryBlack};
    }
    /*copy icon  */
    span {
      padding: 5px;
      svg {
        cursor: pointer;
        height: 13px;
        margin-left: 5px;
        margin-top: -2px;
      }
    }
  }

  /* childres */
  &:nth-child(1) {
    width: 100px;
    display: flex;
    svg {
      width: 100%;
    }
  }
  &:nth-child(2) {
    width: 220px;
  }
  &:nth-child(3) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 30px;
    width: 230px;
  }
  &:nth-child(4) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 30px;
  }
  &:nth-child(5) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 30px;
    line-height: 42px;
  }
  &:nth-child(6) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 30px;
    line-height: 42px;
    svg {
      width: fit-content;
    }
  }

  /* current svg */
  svg {
    height: 63px;
    width: fit-content;
  }

  /* responsive */
  ${Responsive.laptop} {
    font-size: 12px;
    /* childres */
    &:nth-child(1) {
      width: 100px;
      svg {
        width: 100%;
      }
    }
    &:nth-child(2) {
      width: 170px;
      padding-left: 50px;
    }
    &:nth-child(3) {
      width: 190px;
      padding-left: 30px;
    }
    &:nth-child(4) {
      width: 150px;
      padding-left: 30px;
    }
    &:nth-child(5) {
      width: 80px;
      padding-left: 20px;
    }
  }

  /* responsive */
  ${Responsive.tablet} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0px;
    width: 100%;

    /* childres */
    &:nth-child(1) {
      justify-content: center;
      margin-bottom: 30px;
      display: none;
      svg {
        height: 70px;
      }
    }
    &:nth-child(2) {
      padding-left: 0px;
      border: 0px;
      padding-bottom: 20px;
      margin-bottom: 10px;
      width: 100%;
      span {
        width: 100%;
        display: block;
        position: relative;
      }
      div:nth-of-type(2) {
        margin-top: 5px;
      }
      svg {
        height: 35px;
      }
    }
    &:nth-child(3) {
      padding-left: 0px;
      border: 0px;
      border-bottom: 1px solid ${Colors.secondaryGrey};
      padding-bottom: 20px;
      margin-bottom: 20px;
      width: 100%;
      svg {
        height: 40px;
        margin-top: 0px;
      }

      div:first-of-type {
        align-items: flex-start;
        span {
          padding: 0px;
          margin-top: 10px;
        }
      }
      div:last-of-type {
        align-items: flex-end;
      }
      div {
        display: flex;
        flex-direction: column;
        align-items: unset;
        text-align: left;
        span {
          /* margin-top: 4px; */
          padding: 0px;
          margin-top: 5px;
          svg {
            width: 13px;
          }
        }
        span:first-of-type {
          display: none;
        }
      }
    }
    &:nth-child(4) {
      padding-left: 0px;
      border: 0px;
      padding-bottom: 20px;
      div:nth-of-type(2) {
        display: none;
      }
    }
    &:nth-child(5) {
      padding-left: 0px;
      border: 0px;
      display: none;
      span:first-of-type {
        display: block;
      }
    }
    &:nth-child(6) {
      padding-left: 0px;
      border: 0px;
      /* width: 100%; */
      svg {
        height: 44px;
        width: fit-content;
        display: flex;
        justify-content: flex-start;
      }
      span svg {
        display: none;
      }
    }
  }

  ${Responsive.mobile} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0px;
    width: 100%;

    /* childres */
    &:nth-child(1) {
      justify-content: center;
      margin-bottom: 30px;
      display: none;
      svg {
        height: 70px;
      }
    }
    &:nth-child(2) {
      padding-left: 0px;
      border: 0px;
      padding-bottom: 20px;
      margin-bottom: 10px;
      width: 100%;

      span {
        width: 100%;
        display: block;
        position: relative;
      }
      div:nth-of-type(2) {
        margin-top: 5px;
      }
      svg {
        height: 35px;
      }
    }
    &:nth-child(3) {
      padding-left: 0px;
      border: 0px;
      border-bottom: 1px solid ${Colors.secondaryGrey};
      padding-bottom: 20px;
      margin-bottom: 20px;
      width: 100%;
      svg {
        height: 40px;
      }

      div:first-of-type {
        align-items: flex-start;
        span {
          padding: 0px;
          margin-top: 10px;
        }
      }
      div:last-of-type {
        align-items: flex-end;
      }
      div {
        display: flex;
        flex-direction: column;
        align-items: unset;
        text-align: left;
        flex-basis: 50%;
        span {
          /* margin-top: 4px; */
          padding: 0px;
          margin-top: 5px;
          svg {
            width: 13px;
          }
        }
        span:first-of-type {
          display: none;
        }
      }
    }
    &:nth-child(4) {
      padding-left: 0px;
      border: 0px;
      padding-bottom: 20px;
      div:nth-of-type(2) {
        display: none;
      }
    }
    &:nth-child(5) {
      padding-left: 0px;
      border: 0px;
      display: none;
      span:first-of-type {
        display: block;
      }
    }
    &:nth-child(6) {
      padding-left: 0px;
      border: 0px;
      /* width: 100%; */
      svg {
        height: 44px;
        width: fit-content;
        display: flex;
        justify-content: flex-start;
      }
      span svg {
        display: none;
      }
    }
  }
`
const ContentStylesMobile = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
  ${Responsive.tablet} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`
const HeaderDiv = styled.div`
  color: ${Colors.primaryBlack};
`
const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  user-select: none;
  /* background-color: red; */
  /* responsive */
  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }

  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`
const MobileCard = styled.div`
  display: none;
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  ${Responsive.mobile} {
    display: block;
    padding-inline: 24px;
  }
  ${Responsive.tablet} {
    display: block;

    padding-inline: 24px;
  }
`
const Card = styled.div`
  width: 100%;
  background-color: ${Colors.white};
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 135px;
  padding-left: 50px;
  padding-right: 50px;
  margin-bottom: 32px;
  cursor: pointer;

  /* responsive */
  ${Responsive.laptop} {
    padding-left: 20px;
    padding-right: 30px;
  }
  ${Responsive.tablet} {
    flex-direction: column;
    justify-content: center;
    height: fit-content;
    padding: 30px 25px 10px;
    margin-bottom: 20px;
    overflow-x: hidden;
    display: none;
  }
  ${Responsive.mobile} {
    flex-direction: column;
    justify-content: center;
    height: fit-content;
    padding: 30px 25px 10px;
    margin-bottom: 20px;
    overflow-x: hidden;
    display: none;
  }
`
const MobileIcon = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: block;
    /* div input {
      margin-right: -10px;
    } */
    width: 90px;
  }
  ${Responsive.tablet} {
    display: block;
    /* div input {
      margin-right: -10px;
    } */
    width: 90px;
  }
`
const MobileStatusDiv = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: block;
    position: relative;
    text-transform: capitalize;
    margin-right: 15px;
  }
  ${Responsive.tablet} {
    display: block;
    position: relative;
    text-transform: capitalize;
    margin-right: 15px;
  }
`

export default HorizontalPolicyCard
